import { createFileRoute, useParams } from '@tanstack/react-router';

import { Loader } from '@/components/Loading';
import { Text } from '@/components/Typography';
import { Dialog } from '@/components/ui/dialog';
import { TaskDialogContent } from '@/features/boe-task/components/TaskDialog';
import { useTranslation } from '@/lib/i18n';

import { useTaskDialog } from './-hooks/useTaskDialog';

export const Route = createFileRoute('/_staff/cockpit/task/$taskId/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { taskId } = useParams({ from: '/_staff/cockpit/task/$taskId/' });
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.cockpit.detail',
  });

  const {
    open,
    setOpen,
    variant,
    header,
    description,
    todoProps,
    formProps,
    receiveProps,
    isLoading,
    error,
    hasData,
  } = useTaskDialog(taskId);

  // ローディング中
  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader />
      </div>
    );
  }

  // エラー
  if (error) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Text variant="p" className="text-red-600">
          {t('error')}
        </Text>
      </div>
    );
  }

  // データがない場合
  if (!hasData) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Text variant="p" className="text-red-600">
          {t('error')}
        </Text>
      </div>
    );
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <TaskDialogContent
        variant={variant}
        header={header}
        description={description}
        todoProps={todoProps}
        formProps={formProps}
        receiveProps={receiveProps}
      />
    </Dialog>
  );
}
